module.exports = __webpack_public_path__ + "images/emoji/rocket.094153cf5f5bff28524f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rocket.png
// module id = kXxm
// module chunks = 2